exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MsgeifVcDemo h4[data-v-0cf537e5]{color:#066}.MsgeifVcDemo .demoItem[data-v-0cf537e5]{margin-right:15px}", ""]);

// exports
